<template>
    <div >
        <ul>
            <li class="nav-options-list-li"
                    :style="{display:'inline-block', textAlign: 'center'}"
                    :name="item.name"
                    v-for="(item,index) in navTabList"
                    @click="checkOption(item)"
                    v-show="!item.meta || !item.meta.hidden"
                    :key="index">
                    <a class="child-item">{{$t(item.title)}}</a>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: "nav-options",
        props: {
            navTabList: Array
        },
        data() {
            return {}
        },
        components: {},
        methods: {
            //跳转页面
            checkOption(name) {
                this.$emit('on-change', name);
            },
        },
    }
</script>

<style scoped lang="less">
    MenuItem:hover {
        background-color: #f0faff;
    }
    ul{
        display: flex;
        justify-content: flex-start;
    }
    li {
        font-size: 14px;
        height: 30px;
        line-height: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        margin: 10px 0;
        /*width: 25%;*/
        padding: 0 10px;
        a{
            font-size: 16px;
        }
    }

    li:hover {
        background-color: #dfecf4;
    }

</style>